export default () => {
  document.location.href = `${process.env.REACT_APP_IDCLOUD_HOST}?app=id360&path=/admin/profile/new`;
  return null;
};
